import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import DialogTitle from './DialogTitle';
import { apiPost, getZ3PConfiguration } from '../brainApi';
import { storeZ3PConfiguration } from '../helper';

const useStyles = makeStyles((theme) => ({
  submitCodeButton: {
    borderRadius: '6px',
    color: theme.palette.background.default,
    backgroundColor: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    '&:hover': {
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
    },
    ' &.MuiButtonBase-root:disabled': {
      color: theme.palette.background.default,
    },
  },
}));

const GoogleAuthModal = ({
  onClose = () => {},
  onSuccess = () => {},
  open = false,
}) => {
  const [googleAuthCode, setGoogleAuthCode] = useState(null);
  const [googleAuthError, setGoogleAuthError] = useState(false);
  const [sendingGoogleAuthRequest, setSendingGoogleAuthRequest] = useState(
    false,
  );
  const classes = useStyles();

  return (
    <Dialog open={open}>
      <DialogTitle onClose={onClose}>Connect to Google Calendar</DialogTitle>
      <MuiDialogContent>
        <Box
          display="flex"
          alignItems="center"
          gridGap={16}
          justifyContent="center"
        >
          <TextField
            error={googleAuthError}
            id="standard-basic"
            helperText={googleAuthError && 'Invalid code'}
            label="Enter code"
            onChange={(e) => {
              setGoogleAuthCode(e.target.value);
              setGoogleAuthError(false);
            }}
            value={googleAuthCode}
            variant="standard"
          />
          <Button
            className={classes.submitCodeButton}
            disabled={!googleAuthCode || sendingGoogleAuthRequest}
            onClick={async () => {
              setSendingGoogleAuthRequest(true);
              const res = await apiPost('/integration/google/auth', {
                authorization_code: googleAuthCode,
              });
              // Must Get z3p configuration since values will be updated
              const z3pConfiguration = await getZ3PConfiguration();
              storeZ3PConfiguration(z3pConfiguration);
              setSendingGoogleAuthRequest(false);

              if (res.Status === 'Success' && !!res.Email) {
                setGoogleAuthCode(null);
                onClose();
                onSuccess(res.Email);
              } else {
                setGoogleAuthError(true);
              }
            }}
          >
            Submit Code
          </Button>
        </Box>
      </MuiDialogContent>
    </Dialog>
  );
};

export default GoogleAuthModal;
